import React from "react";
import { Gift, ArrowRight, Sparkles } from "lucide-react";

export function ReferralBanner({ onOpen, summary }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      data-testid="referral-banner"
      className="group relative w-full overflow-hidden rounded-2xl border border-ag7-magenta/40 bg-gradient-to-r from-[#24102d] via-[#17213b] to-[#0d2a31] px-4 py-4 text-left shadow-[0_18px_38px_-20px_rgba(236,72,153,0.7)] transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-0.5 hover:border-ag7-cyan/60 hover:shadow-[0_22px_44px_-18px_rgba(6,182,212,0.65)]"
    >
      <div className="pointer-events-none absolute inset-0 opacity-50 bg-[linear-gradient(115deg,transparent_20%,rgba(236,72,153,0.12)_45%,transparent_70%)]" />
      <div className="relative flex items-center gap-3 sm:gap-4">
        <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl border border-ag7-magenta/60 bg-ag7-magenta/15 shadow-[0_0_20px_rgba(236,72,153,0.45)]">
          <Gift className="h-5 w-5 text-ag7-magenta" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="flex items-center gap-1.5 text-[10px] font-mono font-bold uppercase tracking-widest text-cyan-300"><Sparkles className="h-3 w-3" /> Programa AG7</span>
          <span className="mt-0.5 block font-heading text-base font-black text-white sm:text-lg">Invita amigos y gana saldo</span>
          <span className="mt-0.5 block text-xs text-zinc-300">{summary?.referred_count || 0} amigos vinculados · recompensa al completar sus recargas</span>
        </span>
        <ArrowRight className="h-5 w-5 flex-shrink-0 text-ag7-cyan transition-transform duration-200 group-hover:translate-x-1" />
      </div>
    </button>
  );
}